export interface Violation {
  propertyPath: string;
  message: string;
}

/**
 * Convert API Platform constraint violations into a Mantine form error object.
 * Symfony list paths use `[i]`; Mantine form paths use `.i.`.
 */
export function mapViolations(violations: Violation[]): Record<string, string> {
  const errors: Record<string, string> = {};

  for (const violation of violations) {
    const path = violation.propertyPath.replace(/\[([^\]]+)\]/g, '.$1');
    if (!(path in errors)) {
      errors[path] = violation.message; // keep the first message per field
    }
  }

  return errors;
}
